<template>
    <pm-header class="mb-3"></pm-header>
    <pm-datatable v-if="!isMobile" />
    <pm-mobile v-else :rows="rows" :total="total" @refresh="loadData" @new-record="newRecord" @edit-record="editRecord" />
    <router-view name="modal"></router-view>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, RouterView } from "vue-router";
import Api, { ApiResponse } from "@/services/ApiService";
import type { PMModel } from "@/models/PMModel";
import PmDatatable from "@/components/PMs/PMDatatable.vue";
import PmMobile from "@/components/PMs/PMMobile.vue";
import PmHeader from "@/components/PMs/PMHeader.vue";

const router = useRouter();
const isMobile = ref(false);
let mediaQuery: MediaQueryList | null = null;

onMounted(() => {
    if (typeof window !== 'undefined') {
        mediaQuery = window.matchMedia('(max-width: 767px)');
        isMobile.value = mediaQuery.matches;
        mediaQuery.addEventListener('change', (e: MediaQueryListEvent) => { isMobile.value = e.matches; });
        if (isMobile.value) { loadData(); }
    }
});

onUnmounted(() => { if (mediaQuery) { mediaQuery.removeEventListener('change', (e: any) => {}); } });

const total = ref(0);
const rows = ref<PMModel[]>([]);

const loadData = async () => {
    try {
        const params: any = { Page: 0, Size: 100, IncludeLinkedRequest: true };
        const response: ApiResponse<PMModel[]> = await Api.loadPMs(params);
        rows.value = response.Data || [];
        total.value = response.Meta?.Total || 0;
    } catch (error) {
        console.error('Failed to load data:', error);
        rows.value = []; total.value = 0;
    }
};

const newRecord = () => { router.push({ path: "/pm/new" }); };
const editRecord = (id: number) => { router.push({ path: "/pm/edit/" + id }); };
</script>
